export default __webpack_public_path__ + "assets/images/8594550b8a16b9a19d27c5524e730c8e.png";